import React, {Component} from "react";
import {
    Button, FormField,
    FormSection, Hint,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import {GeneLifeDict} from "../translate/GeneLife";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

I18n.setLanguage('ja-JP');
I18n.putVocabularies(GeneLifeDict);

export class ForgetPasswordComponent extends Component {
    render() {
        const message = this.props.delivery || this.props.username ?
            ["Explanation to change your password"]
            : ["Purpose to your registered email address","Reason to your registered email address","Please check the authorization code sent to your registered email address"]
        return (
            <div>
            <Header/>
            <div className="content_wrapper">
              <h2 className="title_content" theme={this.props.theme}>{I18n.get("Reset password")}</h2>

              <div className="container">
            <FormSection theme={this.props.theme}>
            <SectionBody theme={this.props.theme}>
                <FormField theme={this.props.theme}>
                    <Hint theme={this.props.theme}>
                        {message.map((msg, index) => {
                            return <p key={index}>{I18n.get(msg)}</p>;
                        })}
                    </Hint>
                </FormField>
                {this.props.delivery || this.props.username ? this.props.myForgotPassword.submitView() : this.props.myForgotPassword.sendView()}
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    {this.props.delivery || this.props.username ?
                        <Button theme={this.props.theme} disabled={this.props.isSubmitDisabled} onClick={this.props.submit}>{I18n.get("Submit")}</Button> :
                        <Button theme={this.props.theme} disabled={this.props.isSendDisabled}
                                onClick={this.props.myForgotPassword.send}>{I18n.get("Send Code")}</Button>
                    }
                </SectionFooterPrimaryContent>
                <SectionFooterSecondaryContent theme={this.props.theme}>
                    {this.props.delivery || this.props.username ?
                        <Link theme={this.props.theme} style={this.props.resendCodeStyle} disabled={this.props.isSendDisabled} onClick={this.props.myForgotPassword.send}>{I18n.get("Resend Code")}</Link> :
                        <Link theme={this.props.theme} style={STYLE_LINK} onClick={this.props.changeStateFunc}>
                            {I18n.get("Back to Sign In")}
                        </Link>
                    }
                </SectionFooterSecondaryContent>
            </SectionFooter>
        </FormSection>
        </div>

        </div>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

ForgetPasswordComponent.propTypes = {
    theme: PropTypes.any,
    delivery: PropTypes.any,
    username: PropTypes.any,
    myForgotPassword: PropTypes.any,
    submit: PropTypes.func,
    isSendDisabled: PropTypes.bool,
    isSubmitDisabled: PropTypes.bool,
    resendCodeStyle: PropTypes.object,
    changeStateFunc: PropTypes.func
};
